import { useQuery } from "react-query";

import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { zodParseWithLog } from "src/api/apiErrorLogs";

import { IngredientReferenceSchemaZod } from "./useAllIngredientReferences";

export const getOneIngredientReferenceKey = "oneIngredientReference" as const;

type Options = {
    enabled?: boolean;
};

export const useGetOneIngredientReference = (ingredientReferenceId: number | string | undefined, options?: Options) => {
    const { enabled = true } = options || {};

    const query = useQuery({
        queryKey: [getOneIngredientReferenceKey, ingredientReferenceId],
        enabled: enabled && ingredientReferenceId !== undefined,
        cacheTime: 0,
        queryFn: async () => {
            const url = `/api/ingredient-references/${ingredientReferenceId}`;
            return await loggedInApiCall.get(url);
        },
        select: (request) => {
            const data = zodParseWithLog(request.data, IngredientReferenceSchemaZod, getOneIngredientReferenceKey);
            return data;
        },
    });

    return {
        ingredientReference: query.data,
        ...query,
    };
};
